import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Tally3: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 4v16' }],
    ['path', { d: 'M9 4v16' }],
    ['path', { d: 'M14 4v16' }],
  ],
];

export default Tally3;
